import { render } from "./RegisterPopup.vue?vue&type=template&id=4a6d92ab&scoped=true"
import script from "./RegisterPopup.vue?vue&type=script&lang=js"
export * from "./RegisterPopup.vue?vue&type=script&lang=js"

import "./RegisterPopup.vue?vue&type=style&index=0&id=4a6d92ab&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6d92ab"]])

export default __exports__